import _ from 'lodash';
import productPriceListReducer from '../reducers/productPriceList';
import api from '../../services/api';

export function getProductPriceList(query = {}) {
  return (dispatch) => {
    return api.productPriceList
      .find(_.merge({query: {$sort: {id: [-1]}, $limit: 10}}, query))
      .then(({data, ...totals}) => {
        dispatch(productPriceListReducer.Creators.setProductPriceList(data));
        dispatch(productPriceListReducer.Creators.setProductPriceListTotals(totals));
        return {data, ...totals};
      })
  }
}

export function updateInternalCode(dataTest) {
  return (dispatch) => {
    dispatch(productPriceListReducer.Creators.addProductPriceList([dataTest]))
    return dataTest;
  }
}